<div class="items-catalog-container">
	<!-- En-tête avec barre de recherche et bouton d'ajout -->
	<div class="catalog-header">
		<div class="search-section">
			<div class="search-container">
				<div class="search-input-wrapper">
					<i class="bi bi-search search-icon"></i>
					<input type="text" class="search-input" placeholder="Rechercher un bazar..." [(ngModel)]="searchText" />
					@if (searchText) {
						<button class="clear-search" (click)="searchText = ''">
							<i class="bi bi-x-circle"></i>
						</button>
					}
				</div>
			</div>

			@if ((isAdmin$ | async) && !isInCharacterCreation) {
				<div class="admin-controls">
					<button class="add-item-btn" (click)="openCreateBazarModal()">
						<i class="bi bi-plus-circle"></i>
						<span>Ajouter un bazar</span>
					</button>
				</div>
			}
		</div>
	</div>

	<!-- Section Bazars -->
	@if (bazar$ | async | filterList: searchText : filterFn; as filteredBazars) {
		<div class="item-section">
			<div class="section-header">
				<h2 class="section-title">
					<i class="bi bi-basket3"></i>
					Bazars & Objets Divers
					<span class="item-count">({{ filteredBazars.length }})</span>
				</h2>
			</div>

			<!-- Version Desktop - Table -->
			<div class="desktop-view d-none d-lg-block">
				<div class="table-wrapper">
					<table class="items-table">
						<thead>
							<tr>
								<th class="col-name"><i class="bi bi-tag"></i> Nom</th>
								<th class="col-price"><i class="bi bi-coin"></i> Prix</th>
							</tr>
						</thead>
						<tbody>
							@for (item of filteredBazars; track item) {
								<tr class="item-row">
									<td class="item-name">
										<div class="name-cell">
											<div class="item-icon bazar">
												<i class="bi bi-basket3"></i>
											</div>
											<span class="name-text">{{ item.nom }}</span>
										</div>
									</td>
									<td class="item-price">
										<span class="price-value">
											<i class="bi bi-coin text-warning"></i>
											{{ item.prix }}
										</span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>

			<!-- Version Mobile - Cards -->
			<div class="mobile-view d-lg-none">
				<div class="items-grid bazar-grid">
					@for (item of filteredBazars; track item) {
						<div class="item-card bazar-card">
							<div class="card-header">
								<div class="item-icon">
									<i class="bi bi-basket3"></i>
								</div>
								<h5 class="item-name">{{ item.nom }}</h5>
								<span class="item-type-badge">Bazar</span>
							</div>
							<div class="card-body">
								<div class="item-price-section">
									<div class="price-display">
										<i class="bi bi-coin text-warning"></i>
										<span class="price-label">Prix:</span>
										<span class="price-amount">{{ item.prix }}</span>
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	}

	<!-- Message si aucun résultat -->
	<!--@if (searchText && !hasResults()) {
	  <div class="no-results">
		<div class="no-results-content">
		  <i class="bi bi-basket"></i>
		  <h3>Aucun bazar trouvé</h3>
		  <p>Essayez avec des termes de recherche différents</p>
		  <button class="btn-clear-search" (click)="searchText = ''">
			<i class="bi bi-arrow-clockwise"></i>
			Effacer la recherche
		  </button>
		</div>
	  </div>
	}-->
</div>
